import React from 'react'
import ChatBox from '../components/ChatBox/ChatBox'

const Chat = () => {
  return (
    <div>

        <ChatBox />
    </div>
  )
}

export default Chat